import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.5 4.08333C2.5 3.20888 3.20888 2.5 4.08333 2.5H25.9167C26.7911 2.5 27.5 3.20888 27.5 4.08333V25.9167C27.5 26.7911 26.7911 27.5 25.9167 27.5H4.08333C3.20888 27.5 2.5 26.7911 2.5 25.9167V4.08333Z",
      stroke: "currentColor",
      "stroke-width": "1.58333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.2299 20C16.9134 20 18.3071 19.3923 19.2179 18.2735L17.7828 16.9475C17.1342 17.7072 16.32 18.0939 15.3541 18.0939C13.5464 18.0939 12.2631 16.8232 12.2631 15C12.2631 13.1768 13.5464 11.9061 15.3541 11.9061C16.32 11.9061 17.1342 12.2928 17.7828 13.0387L19.2179 11.7127C18.3071 10.6077 16.9134 10 15.2437 10C12.2355 10 10 12.0856 10 15C10 17.9144 12.2355 20 15.2299 20Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }